import type { ShipmentQueueKey } from '@/types/shipments';
import {
  SHIPMENT_DISPLAY_STATUS,
  SHIPMENT_QUEUE_FILTER,
} from '@/utils/shipment-status-ui';

export type ShipmentListQueryParamsInput = {
  page: number;
  perPage: number;
  include: string;
  sortField: string | null;
  sortOrder: number;
  activeQueue: ShipmentQueueKey;
  activeMetricFilter: string | null;
  search: string;
  carrier: string[];
  pickupFromUtcIso: (d: Date) => string;
  pickupToUtcIso: (d: Date) => string;
  pickupFromDate: Date | null;
  pickupToDate: Date | null;
};

export function buildShipmentListQueryParams(
  input: ShipmentListQueryParamsInput,
): Record<string, unknown> {
  const params: Record<string, unknown> = {
    page: input.page,
    per_page: input.perPage,
    include: input.include,
  };

  if (input.sortField) {
    params.sort =
      input.sortOrder === -1 ? `-${input.sortField}` : input.sortField;
  }

  if (input.activeQueue === SHIPMENT_QUEUE_FILTER.draft) {
    params.status = SHIPMENT_DISPLAY_STATUS.Draft;
    params.archived = 0;
  } else if (input.activeQueue === SHIPMENT_QUEUE_FILTER.Closed) {
    params.status = SHIPMENT_QUEUE_FILTER.Closed;
  } else if (input.activeQueue !== SHIPMENT_QUEUE_FILTER.all) {
    params.status = input.activeQueue;
    params.archived = 0;
  }

  if (input.activeMetricFilter === 'active_shipments') {
    params.status = SHIPMENT_DISPLAY_STATUS.Active;
    params.archived = 0;
  } else if (input.activeMetricFilter === 'late_delivery') {
    params.status = SHIPMENT_QUEUE_FILTER.Late;
    params.archived = 0;
  } else if (input.activeMetricFilter === 'picked_up_today') {
    const today = new Date();
    params.pickup_from = input.pickupFromUtcIso(today);
    params.pickup_to = input.pickupToUtcIso(today);
  } else if (input.activeMetricFilter === 'delivery_today') {
    const today = new Date();
    params.delivery_from = input.pickupFromUtcIso(today);
    params.delivery_to = input.pickupToUtcIso(today);
  }

  if (input.search) {
    params.search = input.search;
  }

  if (input.carrier.length) {
    params.carrier = input.carrier.join(',');
  }

  if (input.pickupFromDate) {
    params.pickup_from = input.pickupFromUtcIso(input.pickupFromDate);
  }
  if (input.pickupToDate) {
    params.pickup_to = input.pickupToUtcIso(input.pickupToDate);
  }

  return params;
}
